import { Form } from "antd";

import DiscountCodeListFiled from "./partials/DiscountCodeListFiled";

const DiscountCodes = () => (
  <Form.Item name={["input", "discountCodes"]}>
    <DiscountCodeListFiled />
  </Form.Item>
);

export default DiscountCodes;
